import React from 'react';
import { useSearchParams } from 'react-router-dom';
import { CheckIcon, MessageCircleIcon } from 'lucide-react';
import { useSeo } from '../utils/seo';
import { SimulacionCreditoForm } from '../components/forms/SimulacionCreditoForm';
import { ButtonAnchor } from '../components/ui/Button';
import { GENERAL_WA_MESSAGE, whatsappLink } from '../utils/vehicles';
const puntos = ['Simulación hasta el 100% del valor del vehículo', 'Evaluamos anticipo, permuta y perfil bancario', 'Alternativas con y sin garante', 'Respuesta rápida y sin compromiso'];
export function SimulacionCredito() {
  const [params] = useSearchParams();
  useSeo('Simulá tu crédito hasta el 100% | VCARS', 'Completá la simulación de crédito de VCARS: evaluamos anticipo, permuta, perfil bancario y garante para armar tu plan de financiación.');
  return <main className="bg-ink" data-id="element-753" data-mp="1g2bt207eq3sl">
      <div className="border-b border-line bg-surface" data-id="element-754" data-mp="1baakao9g6v7b">
        <div className="mx-auto grid w-full max-w-7xl gap-10 px-5 py-14 md:grid-cols-[1.1fr_1fr] md:px-8 md:py-20" data-id="element-755" data-mp="1b8pq4zr1pe9z">
          <div data-id="element-756" data-mp="3sujjb4v1nmf">
            <h1 className="text-4xl font-black leading-[1.05] tracking-tight text-white md:text-[52px]" data-id="element-757" data-mp="8pupzn5mgse2">
              Financiación hasta el 100%
            </h1>
            <p className="mt-5 text-lg font-semibold text-white/90" data-id="element-758" data-mp="3r3c1mt1h1ddt">
              Simulá tu crédito y conocé tus opciones reales.
            </p>
            <p className="mt-3 max-w-xl text-base leading-relaxed text-mist" data-id="element-759" data-mp="3h5xmqxv74wnm">
              Con unas pocas preguntas evaluamos tu perfil y te decimos hasta cuánto
              podés financiar, con qué anticipo y en cuántas cuotas. Sin costo y sin
              compromiso.
            </p>

            <ul className="mt-7 grid gap-3 sm:grid-cols-2" data-id="element-760" data-mp="3c6l1uinvxzno">
              {puntos.map(p => <li key={p} className="flex items-start gap-2.5" data-id="element-761" data-mp="16dmnki8ldvm6">
                  <span className="mt-0.5 grid h-6 w-6 shrink-0 place-items-center rounded-full bg-neon/15 text-neon" data-id="element-762" data-mp="16ee8mz4kcay7">
                    <CheckIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-763" data-mp="1acvj9sn703kd" />
                  </span>
                  <span className="text-[14.5px] font-medium text-white" data-id="element-764" data-mp="2j9sb2e5os8y4">{p}</span>
                </li>)}
            </ul>

            <div className="mt-8" data-id="element-765" data-mp="2aaoq14myljgz">
              <ButtonAnchor href={whatsappLink(GENERAL_WA_MESSAGE)} variant="whatsapp" size="lg" data-id="element-766" data-mp="2ac02dsugzzjp">
                <MessageCircleIcon className="h-4 w-4" aria-hidden="true" data-id="element-767" data-mp="322w6o52gsvvd" />
                Hablar con un vendedor
              </ButtonAnchor>
            </div>
          </div>

          <div data-id="element-768" data-mp="2taccphx4bfgv">
            <SimulacionCreditoForm vehiculoInicial={params.get('vehiculo') ?? ''} data-id="element-769" data-mp="2t9sue03k2p2b" />
          </div>
        </div>
      </div>
    </main>;
}